import axios from 'axios';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { useCallback } from 'react';
import dayjs from 'dayjs';
import { message } from 'antd';

export const useSearchVoterInformationByHash = ({ activity, removeHasCallback }) => {
  const { search } = useLocation();
  const { h: voterHash } = queryString.parse(search);

  const removeQueryParam = useCallback(() => {
    const url = new URL(window.location.href);
    url.searchParams.delete('h');
    removeHasCallback?.();
    window.history.replaceState({}, document.title, url.toString());
  }, [removeHasCallback]);

  const searchVoterInfoByHash = useCallback(async () => {
    try {
      const contactId = voterHash.split('-')?.[0];

      if (!contactId) return;

      const { data } = await axios.get(
        `/api/v2/client/voter_registrations/${contactId}?h=${voterHash}&campaign_id=${activity?.campaign?.id}&activity_id=${activity?.id}`,
      );

      const voterFile = data.voterfile;

      const voter = {
        ...data,
        addressLine1: data.address,
        addressLine2: `${data.city}, ${data.state_abbrev}`,
        ageRange: voterFile?.['vb.voterbase_age'],
        city: data.city,
        // convert into the right format
        date_of_birth: dayjs(data.date_of_birth).format('MM/DD/YYYY'),
        name: `${data.first_name} ${data.last_name}`.toLowerCase(),
        state: data.state_abbrev,
        voterbaseId: voterFile?.['voterbase_id'],
        voterfile: {
          ...voterFile,
          'vb.voterbase_registration_status': data.registration_status,
        },
        zip: voterFile?.['vb.tsmart_zip'],
      };

      removeQueryParam();
      return voter;
    } catch (e) {
      const errorMessage = e.response.data.message ?? 'Error retrieving voting information';
      message.error(errorMessage);
    }
  }, [activity?.campaign?.id, activity?.id, removeQueryParam, voterHash]);

  return { searchVoterInfoByHash };
};
